import { RouteType } from '@Pages/RetroSynthesis/constants';

export const getSynthesisMenuOptionsForRouteType = (synthesisMenuOptions, routeType) => {
  // return all options,
  // if it is a Reaxys Compound - it should display both Find preparations and Create retrosynthesis plans
  return synthesisMenuOptions;
}
